class Logo extends google.maps.OverlayView {

    constructor(element) {
        super();

        this.element = element;
        this.updateDOM();

        this.stopEventPropagation();
      
    }

    moveTop() {
        this.anchor.style['bottom'] = "initial";
        this.anchor.style['top'] = "0px";
    }

    updateDOM() {
        var self = this;

        if (!this.anchor) {
            this.anchor = document.createElement('a');
            this.anchor.id = "themaplogo";
            var img = document.createElement('img');
            img.src="https://maps.crm-map.com/dist/logowide-small.png";
            img.style['width'] = "100px";
           
            this.anchor.appendChild(img);
         //   this.anchor.style['z-index'] = "1000000";
            this.anchor.style['position'] = "absolute";
            this.anchor.style['left'] = "0px";
            this.anchor.style['right'] = "0px";
            this.anchor.style['text-align'] = "center";
            this.anchor.style['bottom'] = "0px";
            this.anchor.style['cursor'] = "pointer";

            this.anchor.href="https://crm-map.com/";
            this.anchor.target="_blank";
            this.element.appendChild(this.anchor);
        }

    };



    stopEventPropagation() {
        var anchor = this.anchor;
        anchor.style.cursor = 'auto';

        ['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart',
            'pointerdown']
            .forEach(function (event) {
                anchor.addEventListener(event, function (e) {
                    e.stopPropagation();
                });
            });
    };


}
module.exports = Logo;
